module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control has-addons"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd0b56b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/RadioGroup.vue
// module id = 356
// module chunks = 0